import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateStatus = ({ jobAdID, status }) => {
  try {
    return axios.put(
      `/api/job_ads/${jobAdID}/status`,
      JSON.stringify({ status: status })
    );
  } catch (error) {
    return error;
  }
};

export const useUpdateStatus = (refetch) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: updateStatus,
    onSuccess: () => {
      enqueueSnackbar('Status successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      if (refetch) refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
